module.exports = {
	"title": "Trang xác nhận đặt bàn",
	"privacyPolicy": "Chính sách bảo mật",
	"term": "Điều khoản sử dụng",
	"phoneNumberText": "Bạn có thể xác nhận đặt bàn chi tiết bằng cách nhập số điện thoại tại thời điểm đặt bàn.",
	"phoneNumber": "Số điện thoại",
	"phoneNumberError": "Số điện thoại của bạn không chính xác?\nThời gian xác nhận đặt bàn đã hết hạn.",
	"phoneNumberEnabledButton": "Xác nhận chi tiết đặt bàn",
	"phoneNumberDisabledButton": "Vui lòng nhập số điện thoại của bạn",
	"reservationCanceled": "Đặt bàn này đã bị hủy",
	"reservationCancel": "Đã hủy đặt bàn",
	"course": "Khóa học",
	"address": "Địa chỉ",
	"phone": "thông tin liên hệ",
	"contents": "Chi tiết đặt bàn",
	"date": "Ngày",
	"seats": "Số người",
	"adults": "Người lớn",
	"children": "Trẻ em",
	"request": "Yêu cầu đặc biệt",
	"reservationNumber": "Mã số đặt bàn",
	"noText": "Nếu bạn muốn hủy bỏ hoặc thay đổi thông tin đặt chỗ vui lòng liên hệ trực tiếp cho chúng tôi.",
	"cancelButton": "Nhấn vào đây để hủy bỏ",
	"people": "Tên",
	"confirm": "Bạn có muốn hủy đặt bàn?",
	"start": "Bắt đầu",
	"deposit": "Đặt cọc",
	"table_category": "Loại chỗ ngồi",
	"private": "Phòng riêng",
	"counter": "Quầy làm bánh",
	"table": "bàn",
	"none": "Không chỉ định",
	"yes": "Có",
	"no": "Không",
	"doCancel": "Bạn có chắc chắn sẽ hủy đặt bàn?"
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/vi.json
// module id = 170
// module chunks = 0